import {HibuTag} from '../../../../search-types';

export type ClickableElementsRenderer = (clickableElements: ClickableElement[] | null) => JSX.Element | null;

export type HibuExtendedSpansProps = {
    hibuSpans: HibuTag[];
    renderingFunction: ClickableElementsRenderer
}

export type ClickableElement = {
    id: string;
    label: string;
    bottomLeftY: number;
    pageNumber: number;
    pageHeight: number;
}

function orderElementsByPageAndCoordinate(a: ClickableElement, b: ClickableElement) {
    return a.pageNumber - b.pageNumber || b.bottomLeftY - a.bottomLeftY; // Coordinates are from bottom left, which means that order is reversed compared to page ordering
}

export const ClickableSectionList = (props: HibuExtendedSpansProps) => {
    if (!props.hibuSpans) {
        return null;
    }
    const clickableElements: ClickableElement[] = props.hibuSpans
        .filter(hibuSpan => hibuSpan.spans && hibuSpan.spans.length > 0 && hibuSpan.spans[0].bottomLeftY !== undefined && hibuSpan.spans[0].pageNumber !== undefined)
        .map(hibuSpan => ({
            id: hibuSpan.id,
            label: hibuSpan.label,
            // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
            bottomLeftY: hibuSpan.spans![0].bottomLeftY,
            // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
            pageHeight: hibuSpan.spans![0].pageHeight,
          // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
          pageNumber: hibuSpan.spans![0].pageNumber,
        }))
        .sort(orderElementsByPageAndCoordinate);
    return props.renderingFunction(clickableElements);
};
